import type { MessageContext } from 'vue-i18n';
import type { InfractionText } from './types';

export const portInfractions: Record<string, InfractionText> = {
  HIGH_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}, potentially exposing web content and application functionality.',
    whyRisk: 'Why is this a high risk?',
    risk: 'If {service} is not properly secured, unauthorised users may be able to access sensitive data, deface websites, or use the service as a launching point for further attacks.',
  },
  MEDIUM_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation: ({ named, values }: MessageContext) => {
      const init = `Port ${named('port')} is usually used for ${named('service')}, potentially exposing web content and application functionality.`;
      const dev = `${named('port')} is usually used for internal access to web services in development.`;
      if (typeof values.service === 'string' && values.service.startsWith('Development')) {
        return `${init} ${dev}`;
      }
      return init;
    },
    whyRisk: 'Why is this a medium risk?',
    risk: 'If {service} is not properly secured, unauthorised users may be able to access sensitive data, deface websites, or use the service as a launching point for further attacks.',
  },
  LOW_PORT_EXPOSED: {
    infraction: '{service} port exposed',
    explanation:
      'Port {port} is used for {service}, potentially exposing web content and application functionality.',
    whyRisk: 'Why is this a low risk?',
    risk: 'If {service} is not properly secured, unauthorised users may be able to access sensitive data, deface websites, or use the service as a launching point for further attacks.',
  },
};
